/* Vanillas of the World — self-contained custom search widget.
   Markup lives in header.liquid (`.vw-search` and friends). Fully independent
   of Dawn's search-modal / predictive-search infrastructure.
*/
(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatPrice(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    return '$' + n.toFixed(2);
  }

  /* Aroma notes are stored as product tags. This whitelist mirrors the one in
     sections/product-revamp.liquid so the dropdown shows the same notes the
     product page does. Keep the two lists in sync if either changes. */
  var AROMA_NOTES = [
    'allspice', 'anise', 'apricot', 'buttery', 'candied fruit', 'caramel',
    'cherry', 'chocolate', 'cinnamon', 'clove', 'cocoa', 'cotton candy',
    'creamy', 'dark chocolate', 'dried fruit', 'earthy', 'fig', 'floral',
    'fruity', 'honey', 'licorice', 'marshmallow', 'mocha', 'nutmeg',
    'raisin', 'rum', 'smoky', 'spice', 'tropical', 'wood'
  ];

  function aromaTagsFor(product) {
    var tags = product.tags || [];
    var out = [];
    for (var i = 0; i < tags.length && out.length < 3; i++) {
      if (AROMA_NOTES.indexOf(String(tags[i]).toLowerCase().trim()) !== -1) out.push(tags[i]);
    }
    return out;
  }

  function setupWidget(root) {
    if (root.__vwSearchWired) return;
    root.__vwSearchWired = true;

    var toggle = root.querySelector('[data-vw-search-toggle]');
    var dropdown = root.querySelector('[data-vw-search-dropdown]');
    var input = root.querySelector('[data-vw-search-input]');
    var results = root.querySelector('[data-vw-search-results]');
    var clearBtn = root.querySelector('[data-vw-search-clear]');
    if (!toggle || !dropdown || !input || !results) return;

    function openDropdown() {
      dropdown.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      setTimeout(function () {
        input.focus();
      }, 20);
    }
    function closeDropdown() {
      dropdown.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (dropdown.hidden) openDropdown();
      else closeDropdown();
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) closeDropdown();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDropdown();
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = '';
        clearBtn.hidden = true;
        clearResults();
        input.focus();
      });
    }

    var timeout = null;
    var lastQuery = '';

    function clearResults() {
      results.innerHTML = '';
      results.hidden = true;
    }

    function render(products, query) {
      if (!products.length) {
        results.innerHTML =
          '<p class="vw-typeahead__empty">Nothing found for &ldquo;' +
          escapeHtml(query) +
          '&rdquo;. Press <b>Enter</b> to search pages and articles too.</p>';
        results.hidden = false;
        return;
      }
      var total = products.length;
      var shown = products.slice(0, 6);
      var countLabel =
        '<p class="vw-typeahead__count">' +
        (total >= 10 ? '10+' : total) +
        (total === 1 ? ' result' : ' results') +
        '</p>';

      var itemsHtml = shown
        .map(function (p) {
          var imgUrl = '';
          if (p.featured_image && p.featured_image.url) imgUrl = p.featured_image.url;
          else if (p.image) imgUrl = p.image;
          var img = imgUrl
            ? '<img src="' + escapeHtml(imgUrl) + '" alt="" class="vw-typeahead__img" loading="lazy">'
            : '<div class="vw-typeahead__img vw-typeahead__img--placeholder"></div>';
          var priceHtml = p.price
            ? '<div class="vw-typeahead__price">' + escapeHtml(formatPrice(p.price)) + '</div>'
            : '';
          var notes = aromaTagsFor(p);
          var notesHtml = notes.length
            ? '<div class="vw-typeahead__notes">' +
              notes
                .map(function (n) {
                  return '<span class="vw-typeahead__note">' + escapeHtml(n) + '</span>';
                })
                .join('') +
              '</div>'
            : '';
          return (
            '<a href="' +
            escapeHtml(p.url) +
            '" class="vw-typeahead__item">' +
            img +
            '<div class="vw-typeahead__body">' +
            '<div class="vw-typeahead__title">' +
            escapeHtml(p.title) +
            '</div>' +
            notesHtml +
            priceHtml +
            '</div></a>'
          );
        })
        .join('');

      var seeAll =
        '<a href="/search?q=' +
        encodeURIComponent(query) +
        '" class="vw-typeahead__all">See all results for &ldquo;' +
        escapeHtml(query) +
        '&rdquo; &rarr;</a>';

      results.innerHTML = countLabel + itemsHtml + seeAll;
      results.hidden = false;
    }

    function doFetch(query) {
      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(query) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=10';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          return r.ok ? r.json() : null;
        })
        .then(function (data) {
          if (!data) return;
          var products =
            (data.resources && data.resources.results && data.resources.results.products) || [];
          var q = query.toLowerCase();
          // Rank (don't filter): products whose TITLE matches come first, everything
          // else the API matched (description / tasting notes / tags) follows. This
          // keeps "madagascar" showing Madagascar beans at the top, while still
          // surfacing results for flavour-note searches like "caramel" or "smoky".
          var titleMatches = [];
          var otherMatches = [];
          products.forEach(function (p) {
            if ((p.title || '').toLowerCase().indexOf(q) !== -1) titleMatches.push(p);
            else otherMatches.push(p);
          });
          render(titleMatches.concat(otherMatches), query);
        })
        .catch(function () {
          clearResults();
        });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      clearTimeout(timeout);
      if (q === lastQuery) return;
      lastQuery = q;
      if (q.length < 2) {
        clearResults();
        return;
      }
      timeout = setTimeout(function () {
        doFetch(q);
      }, 180);
    });
  }

  function init() {
    document.querySelectorAll('[data-vw-search]').forEach(setupWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
